export const firebaseEnvConfig = {
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.STORAGE_IMPLEMENTATION === 'firebase-emulator'
        ? process.env.FIREBASE_EMULATOR_PROJECT
        : process.env.FIREBASE_PROJECT,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID,
    apiKey: process.env.FIREBASE_API_KEY,
};
